module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_j_piebald.7bc4cdab.png";